import { forwardRef, Inject, Pipe, PipeTransform } from '@angular/core';
import { ActionState } from '../../model';
import { StatusTagPipe } from './status-tag.pipe';

@Pipe({ name: 'actionState', pure: false })
export class ActionStatePipe implements PipeTransform {

    constructor(
        @Inject(forwardRef(() => StatusTagPipe)) private statusTagPipe: StatusTagPipe
    ) {
    }

    transform(value: ActionState): string {
        switch (value) {
            case ActionState.DONE:
                return this.statusTagPipe.transform(value, { icon: 'check_circle', iconStyle: 'margin-bottom: 2px', color: '#07570E', backgroundColor: '#0EAE1C26' });
            case ActionState.DISCARDED:
                return this.statusTagPipe.transform(value, { icon: null, iconStyle: null, color: '#7C0505', backgroundColor: '#F80A0A26' });
            default: return '';
        }
    }
}

